<mat-sidenav-container (backdropClick)="closeSlideBar()">
	<mat-sidenav position="end" [opened]="sideBarOpened" disableClose>
		<router-outlet name="sidebar"></router-outlet>
	</mat-sidenav>
	<mat-sidenav-content id="main">
		<section class="clamp">
			<mat-grid-list [cols]="breakpoint" rowHeight="1.35:1" gutterSize="20px"
				(window:resize)="onResize($event.target.innerWidth)">
				<mat-grid-tile *ngFor="let article of articles">
					<app-card-article [article]="article" [porteur]="porteur" (onEdit)="editArticle(article)">
					</app-card-article>
				</mat-grid-tile>
				<mat-grid-tile class="click">
					<div class="add-tile" (click)="addArticle()">
						<mat-icon>add_circle_outline</mat-icon>
						<h3>Ajouter un vêtement</h3>
					</div>
				</mat-grid-tile>
			</mat-grid-list>
		</section>
	</mat-sidenav-content>
</mat-sidenav-container>